module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-100.74eb33c3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-100.png
// module id = 3348
// module chunks = 11